import React, { useState } from 'react';
import { LoadingButton } from '../common/LoadingButton';

export const AuthPersonalId = ({ ballot, onValidatePersonalId }) => {
    const [isSubmitting, setSubmitting] = useState(false)
    const [personalId, setPersonalId] = useState("")

    const handleAuth = () => {
        setSubmitting(true)

        // Validate receipt
        onValidatePersonalId(personalId, () => { setSubmitting(false) })
    }

    const handleUserInput = (event) => {
        setPersonalId(event.target.value)
    }

    const personalIdLabel = (ballot && ballot.personalIdLabel) ? ballot.personalIdLabel : "Personal ID"

    return (
        <form noValidate>
            <p className="mb-4 text-center">To vote please enter you {personalIdLabel} and click Submit.</p>

            <div className="mb-4">
                <label htmlFor="receipt" className="block font-medium mb-2">{personalIdLabel}</label>
                <input id="receipt" type="text" onChange={handleUserInput} value={personalId} placeholder={personalIdLabel} required />
            </div>

            <div className="mt-8">
                <LoadingButton className="btn w-full block"
                    btnText="Submit"
                    isLoading={isSubmitting}
                    onBtnClick={handleAuth}
                    isSubmit="true">
                    Submit
                </LoadingButton>
            </div>
        </form>
    );
}